export default "__VITE_ASSET__05aaa9ec__"